import type { ButtonHTMLAttributes, ReactNode } from "react";

import { cx } from "../lib/cx";

export type ButtonVariant = "primary" | "secondary" | "ghost" | "danger";

const base =
  "inline-flex items-center justify-center gap-2 rounded-md text-sm font-medium " +
  "transition-colors disabled:cursor-not-allowed disabled:opacity-50";

const sizes = {
  sm: "h-7 px-2",
  md: "h-9 px-3",
} as const;

const variants: Record<ButtonVariant, string> = {
  primary: "bg-accent text-on-accent hover:bg-accent-hover",
  secondary: "border border-line bg-raised text-ink hover:bg-hover",
  ghost: "text-ink hover:bg-hover",
  danger: "border border-line text-danger hover:bg-hover",
};

export interface ButtonProps extends ButtonHTMLAttributes<HTMLButtonElement> {
  variant?: ButtonVariant;
  size?: keyof typeof sizes;
  children?: ReactNode;
}

export function Button({
  variant = "secondary",
  size = "md",
  className,
  type = "button",
  ...rest
}: ButtonProps): ReactNode {
  return (
    <button type={type} className={cx(base, sizes[size], variants[variant], className)} {...rest} />
  );
}
